module.exports = __webpack_public_path__ + "static/media/yunhaoxueyuanzuzhijiagou.a4503625.png";